<div *ngIf="proposal" class="justify-content-around row w-100">
    <div class="border-end border-end-dashed col-md-6 flex-column row">
        <div class="border-0 col-12">
            <div class="rounded-card card-body p-3 pb-0">
                <h5 class="card-title flex-grow-1 mb-3">{{'t-property-details' |
                    translate}}:</h5>
                <ul class="list-unstyled mb-0 vstack">
                    <li>
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0">
                                <img src="{{proposal.property.image ? pathImage+proposal.property.image : 'assets/images/placeholder.png'}}"
                                    alt="" class="avatar-md rounded">
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="fs-14 mb-1">{{proposal.property.title}}</h6>
                                <p class="text-muted mb-0">{{proposal.property.reference}}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="border-0 col-12">
            <div class="rounded-card card-body p-3 pb-0">
                <h5 class="card-title flex-grow-1 mb-3">{{'t-proposals.t-sent-by' |
                    translate}}:</h5>
                <ul class="list-unstyled mb-0 vstack">
                    <li class="mb-3">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0">
                                <img src="{{proposal.proposal.user && proposal.proposal.user?.userFiles?.length > 0 ? pathProfileImage + proposal.proposal.user?.userFiles[0]?.fileName : 'assets/images/users/user-dummy-img.jpg'}}"
                                    alt="" class="avatar-sm rounded">
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="fs-14 mb-1">{{proposal?.proposal?.user?.name}}</h6>
                                <p class="text-muted mb-0">{{proposal.proposal.user?.store}}</p>
                            </div>
                        </div>
                    </li>
                    <li class="mb-3" *ngIf="proposal?.proposal?.agencyProposal && proposal?.proposal?.partnerEntityName"
                        class="d-flex align-items-center">{{'t-proposals.t-partner-agency' |
                        translate}}:
                        {{proposal.proposal.partnerEntityName}}
                    </li>
                    <li class="mb-3 d-flex align-items-center" *ngIf="proposal?.proposal?.internalShare">
                        <span class="badge badge-soft-info fs-12 me-2">{{'t-proposals.t-internal-share' | translate}}</span>
                        <span *ngIf="proposal?.proposal?.partnerEntityName">{{proposal.proposal.partnerEntityName}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="border-0 col-12">
            <div class="rounded-card card-body p-3">
                <div *ngIf="proposal.proposal?.firstProposal" class="mb-3">
                    <h5 class="card-title flex-grow-1">{{'t-proposals.t-first-proposal' |
                        translate}}</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="mb-1">
                            <div class="mb-1">
                                {{'t-proposals.t-value' |
                                translate}}:
                                {{priceFormat(proposal.proposal.firstProposal?.value)}}
                            </div>
                            <div class="mb-1"
                                *ngIf="proposal.proposal?.agencyProposal && proposal.proposal.firstProposal?.saleDivision">
                                {{'t-proposals.t-share-commission' | translate}}:
                                {{proposal.proposal.firstProposal?.saleDivision}}/{{100 -
                                proposal.proposal.firstProposal?.saleDivision}}</div>
                            <div class="mb-1">{{'t-proposals.t-date' | translate}}:
                                {{getDate(proposal.proposal.firstProposal?.date)}}</div>
                        </div>
                        <button
                            *ngIf="!readOnly && ((permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'DELETE_PROPOSALS') && !['ri-trophy-line', 'ri-check-double-line'].includes(proposal.proposal?.lastAction?.icon)) || permissionsService.checkMasterPermission('DELETE_PROPOSALS', proposal.property?.store?.id))"
                            (click)="deleteProposal(proposal.proposal.id)" class="btn btn-soft-danger px-2 py-1"><i
                                class="ri-delete-bin-2-line"></i></button>
                    </div>
                </div>
                <div *ngIf="proposal.proposal?.lastAction">
                    <h5 class="card-title flex-grow-1">{{'t-proposals.t-last-action' |
                        translate}}</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="mb-1">
                            <div class="mb-1">
                                {{'t-proposals.t-value' |
                                translate}}:
                                {{priceFormat(proposal.proposal.lastAction?.value)}}
                            </div>
                            <div class="mb-1"
                                *ngIf="proposal.proposal?.agencyProposal && proposal.proposal.lastAction?.saleDivision">
                                {{'t-proposals.t-share-commission' | translate}}:
                                {{proposal.proposal.lastAction?.saleDivision}}/{{100 -
                                proposal.proposal.lastAction?.saleDivision}}</div>
                            <div class="mb-1">{{'t-proposals.t-date' | translate}}:
                                {{getDate(proposal.proposal.lastAction?.date)}}</div>
                        </div>
                        <div><span class="badge {{getBadge(proposal.proposal.lastAction?.icon)}}">
                                {{getProposalStatusLabel(proposal.proposal.lastAction) | translate}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="additionalProposalDetails.length > 0 || proposalProposersList.length > 0"
                    class="border-top mt-3 pt-3">
                    <h6 *ngIf="additionalProposalDetails.length > 0" class="fw-semibold mb-2">
                        {{ 't-proposals.t-additional-details' | translate }}
                    </h6>
                    <div class="mb-1" *ngFor="let detail of additionalProposalDetails">
                        <span class="text-muted">{{ detail.label }}:</span>
                        <span class="ms-1">{{ detail.value }}</span>
                    </div>

                    <h6 *ngIf="proposalProposersList.length > 0" class="fw-semibold mb-2 mt-3">
                        {{ 't-proposals.t-proposers' | translate }}
                    </h6>
                    <div *ngFor="let proposer of proposalProposersList" class="mb-2">
                        <div>{{ getProposalProposerName(proposer) }}</div>
                        <small class="text-muted d-block" *ngIf="getProposalProposerTypeLabel(proposer)">
                            {{ 't-proposals.t-proposer-type' | translate }}: {{ getProposalProposerTypeLabel(proposer) }}
                        </small>
                        <small class="text-muted" *ngIf="getProposalProposerIdentifier(proposer)">
                            {{ 't-proposals.t-proposer-tax-id' | translate }}: {{ getProposalProposerIdentifier(proposer) }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 profile-timeline">
        <div class="accordion accordion-flush" id="accordionFlushExample">
            <div *ngFor="let history of proposal.proposal.history; let i = index" class="accordion-item border-0">
                <div class="accordion-header" id="heading{{i}}">
                    <a class="accordion-button p-2 shadow-none" data-bs-toggle="collapse" href="#collapse{{i}}"
                        aria-expanded="true" attr.aria-controls="collapse{{i}}">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 avatar-xs">
                                <div class="avatar-title {{getIconColor(history.icon)}} rounded-circle">
                                    <i class="{{history.icon}} fs-3"></i>
                                </div>
                            </div>
                            <div class="align-items-center d-flex flex-grow-1 gap-3 ms-3">
                                <h6 class="fs-15 mb-0 fw-semibold">{{getProposalStatusLabel(history) | translate}} -
                                    <span class="fw-normal">{{getDate(history.date)}}</span></h6>
                                <button (click)="openEdit()" class="btn btn-soft-info px-2 py-1"
                                    *ngIf="!readOnly && proposal.proposal.history?.length === 1">
                                    <i class="ri-edit-line"></i>
                                </button>
                            </div>
                        </div>
                    </a>
                </div>
                <div id="collapse{{i}}" class="accordion-collapse collapse show" attr.aria-labelledby="heading{{i}}"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body ms-2 ps-5 pt-0">
                        <h6 *ngIf="history?.value" class="mb-1">{{'t-proposals.t-proposal-value' |
                            translate}}:
                            {{priceFormat(history?.value)}}</h6>
                        <p *ngIf="proposal?.proposal?.agencyProposal && history.saleDivision" class="text-muted">
                            {{'t-proposals.t-share-commission' | translate}}:
                            {{history.saleDivision}}/{{100 -
                            history.saleDivision}}</p>
                        <p *ngIf="history.obs" class="text-muted">{{ obsLabelKey(history, proposal.proposal.history) | translate }}:
                            {{history.obs}}</p>
                        <p *ngIf="isDocumentRequested(history)" class="text-muted mb-1">
                            {{ 't-proposals.t-document-requested' | translate }}
                            <span *ngIf="history.documentDeliveredAt">
                                {{ 't-proposals.t-document-delivered-at' | translate }} {{getDate(history.documentDeliveredAt)}}
                            </span>
                        </p>
                        <p *ngIf="history.documentDeadline" class="text-muted mb-1">
                            {{ 't-proposals.t-document-deadline' | translate }}: {{getDate(history.documentDeadline)}}
                        </p>
                        <p *ngIf="isDocumentPending(history)" class="text-warning mb-1">
                            {{ 't-proposals.t-document-pending' | translate }}
                        </p>
                        <ng-container *ngIf="history.file && history.file.length > 0">
                          <div class="d-flex align-items-center pb-2" *ngFor="let file of history.file">
                            <div class="flex-shrink-0 avatar-xs">
                                <div class="avatar-title bg-light rounded">
                                    <i class="ri-file-zip-line fs-20 text-primary"></i>
                                </div>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="mb-1"><a target="_blank"
                                        href="{{dirProposalsFiles}}{{proposal.proposal.id}}/{{file.fileName}}">{{file.originalName}}</a>
                                </h6>
                                <small *ngIf="file?.size"
                                    class="text-muted">{{formatSizeUnits(file.size)}}</small>
                            </div>
                        </div>
                        <!-- Juntar mais documentos ao passo: discreto, por baixo da lista. -->
                        <button type="button" class="btn btn-link btn-sm p-0 fs-12 text-muted text-decoration-none mb-2"
                            *ngIf="!readOnly && isLatestHistoryEntry(history, proposal) && canUploadPendingDocument(proposal)"
                            (click)="openUploadWorkflowDocument(contentUploadWorkflowDocument, history)">
                            <i class="ri-upload-2-line align-bottom me-1"></i>{{ 't-proposals.t-add-documents' | translate }}
                        </button>
                        </ng-container>
                        <div [ngClass]="{'mt-3': !history.obs && history.file?.length == 0}"
                            *ngIf="!readOnly && isLatestHistoryEntry(history, proposal) && canOpenWorkflowFromAccept(proposal)"
                            class="align-items-center d-flex justify-content-around row">
                            <button
                                *ngIf="canDecideProposal(proposal) && (permissionsService.checkMasterPermission('REJECT_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'REJECT_PROPOSALS'))"
                                (click)="refuseProposal(proposal.proposal.id, history?.value)"
                                class="btn btn-outline-danger w-auto">{{'t-proposals.t-refuse' |
                                translate}}</button>
                            <button
                                *ngIf="canCounterProposal(proposal)"
                                (click)="counterProposal(contentCounter, proposal.proposal)"
                                class="btn btn-outline-info w-auto">{{'t-proposals.t-counteroffer' |
                                translate}}</button>
                            <button
                                *ngIf="canDecideProposal(proposal) && (permissionsService.checkMasterPermission('ACCEPT_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'ACCEPT_PROPOSALS')) && !proposal?.property?.saleInProgress"
                                (click)="openWorkflowStep(contentWorkflowStep, 'accept-and-step')"
                                class="btn btn-outline-success w-auto">{{'t-proposals.t-accept' |
                                translate}}</button>
                        </div>
                        <div [ngClass]="{'mt-3': !history.obs && history.file?.length == 0}"
                            *ngIf="!readOnly && isLatestHistoryEntry(history, proposal) && canAdvanceWorkflowStep(proposal) && (permissionsService.checkMasterPermission('VALIDATE_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'VALIDATE_PROPOSALS'))"
                            class="align-items-center d-flex gap-3 mt-3">
                            <button
                                *ngIf="permissionsService.checkMasterPermission('REJECT_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'REJECT_PROPOSALS')"
                                (click)="refuseProposal(proposal.proposal.id, history.value, true)"
                                class="btn btn-outline-danger w-auto">{{'t-proposals.t-cancel' |
                                translate}}</button>
                            <button (click)="openWorkflowStep(contentWorkflowStep)" class="btn btn-outline-success w-auto">
                                {{isRentProposal(proposal) ? ('t-proposals.t-status-lease-agreement' | translate) : isHistoryStatusReserved(history) ? ('t-proposals.t-status-cpcv' | translate) : ('t-proposals.t-status-reservation-cpcv' | translate)}}
                            </button>
                        </div>
                        <div [ngClass]="{'mt-3': !history.obs && history.file?.length == 0}"
                            *ngIf="!readOnly && isLatestHistoryEntry(history, proposal) && canUploadPendingDocument(proposal) && !hasStepFiles(history)"
                            class="align-items-center d-flex gap-3 mt-3">
                            <!-- Documento pendente: cancelar a proposta continua possível. -->
                            <button
                                *ngIf="canCancelPendingDocument(proposal) && (permissionsService.checkMasterPermission('REJECT_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'REJECT_PROPOSALS'))"
                                (click)="refuseProposal(proposal.proposal.id, history.value, true)"
                                class="btn btn-outline-danger w-auto">{{'t-proposals.t-cancel' |
                                translate}}</button>
                            <button (click)="openUploadWorkflowDocument(contentUploadWorkflowDocument, history)"
                                class="btn btn-outline-primary w-auto">{{ 't-proposals.t-upload-document' | translate }}
                            </button>
                        </div>
                        <div [ngClass]="{'mt-3': !history.obs && history.file?.length == 0}"
                            *ngIf="!readOnly && isLatestHistoryEntry(history, proposal) && canCheckWorkflowProposal(proposal) && (permissionsService.checkMasterPermission('VALIDATE_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'VALIDATE_PROPOSALS'))"
                            class="align-items-center d-flex gap-3 mt-3">
                            <button
                                *ngIf="permissionsService.checkMasterPermission('REJECT_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'REJECT_PROPOSALS')"
                                (click)="refuseProposal(proposal.proposal.id, history.value, true)"
                                class="btn btn-outline-danger w-auto">{{'t-proposals.t-cancel' |
                                translate}}</button>
                            <button
                                *ngIf="permissionsService.checkMasterPermission('VALIDATE_PROPOSALS', proposal.property?.store?.id) || permissionsService.checkAgentPermission(proposal.property?.mainAgent?.id, 'VALIDATE_PROPOSALS')"
                                (click)="openCheck(contentCheck)"
                                class="btn btn-outline-success w-auto">{{(isRentProposal(proposal) ?
                                't-proposals.t-check-rent' : 't-proposals.t-check-sale') | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--end accordion-->
    </div>
</div>


<ng-template #contentCounter role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <h5 class="modal-title" id="inviteMembersModalLabel">
            {{'t-proposals.t-counteroffer' | translate}}
        </h5>
        <button type="button" id="proposal-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-4">
        <form [formGroup]="counterProposalForm">
            <div class="row">
                <!-- <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-buyers-name' | translate}}</label>
                    <input type="text" [ngClass]="{ 'is-invalid': submitedCounter && formCounter['clientName'].errors }"
                        [attr.disabled]="true" class="form-control"
                        placeholder="{{'t-proposals.t-buyers-name' | translate}}" formControlName="clientName">
                    <div *ngIf="submitedCounter && formCounter['clientName'].errors" class="invalid-feedback"
                        align="left">
                        {{'t-name-error-required' | translate}}
                    </div>
                </div> -->
                <div *ngIf="proposal?.proposal?.agencyProposal" class="col-md-12 mb-3">
                    <label class="form-label">
                        {{'t-proposals.t-share-commission' | translate}}
                    </label>
                    <div class="values d-flex justify-content-between align-items-center mb-1">
                        <span class="fw-bold">{{'t-proposals.t-my-agency' | translate}}: <span
                                class="fw-normal">{{formCounter['saleDivision'].value}}%</span></span>
                        <span class="fw-bold">{{'t-proposals.t-partner' | translate}}: <span class="fw-normal">{{100 -
                                formCounter['saleDivision'].value}}%</span></span>
                    </div>
                    <input type="range" min="0" max="100" formControlName="saleDivision" class="form-range"
                        id="customRange1">
                </div>
                <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-counteroffer-value' | translate}}</label>
                    <input type="text" class="form-control"
                        [ngClass]="{ 'is-invalid': submitedCounter && formCounter['value'].errors }" mask="separator"
                        thousandSeparator=" " id="priceInput"
                        placeholder="{{'t-proposals.t-counteroffer-value' | translate}}" formControlName="value">
                    <div *ngIf="submitedCounter && formCounter['value'].errors" class="invalid-feedback" align="left">
                        {{'t-proposals.t-counteroffer-value-mandatory' | translate}}
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-observations' | translate}}</label>
                    <textarea class="form-control" formControlName="obs" rows="3"
                        placeholder="{{'t-proposals.t-observations' | translate}}"></textarea>
                </div>
                <div class="col-md-6">
                    <label class="form-label mb-0">{{'t-proposals.t-file-input' | translate}}</label>
                    <div class="d-flex align-items-center py-2 rounded">
                        <input hidden accept=".jpeg, .jpg, .png, .pdf, .doc, .docx" class="form-control" type="file" id="input-filec"
                            (change)="onFileChangeCounter($event)">
                        <a *ngIf="!formCounter['file'].value" href="javascript:void(0);"
                            class="btn btn-outline-primary btn-label waves-effect waves-light btn-sm"
                            (click)="addFileCostumer()">
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    <i class="ri-file-upload-line label-icon align-middle fs-16 me-2"></i>
                                </div>
                                <div class="flex-grow-1">
                                    {{'t-upload-file' | translate}}
                                </div>
                            </div>
                        </a>
                        <div class="d-flex align-items-center border border-dashed p-2 rounded"
                            *ngIf="formCounter['file']?.value">
                            <div class="flex-shrink-0 avatar-sm">
                                <div class="avatar-title bg-light rounded">
                                    <i class="ri-file-zip-line fs-20 text-primary"></i>
                                </div>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="mb-1"><a href="javascript:void(0);">{{formCounter['file'].value?.name}}</a>
                                </h6>
                                <small class="text-muted">{{formatSizeUnits(formCounter['file'].value?.size)}}</small>
                            </div>
                            <div class="hstack gap-3 ms-3 fs-16">
                                <a href="javascript:void(0);" class="text-muted" (click)="deleteFileCounter()"><i
                                        class="ri-delete-bin-line"></i></a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
            (click)="clearFormCounter(); modal.close('')">{{'t-proposals.t-cancel' | translate}}</button>
        <button type="button" class="btn btn-primary w-xs" (click)="submitCounterProposal()">
            {{'t-proposals.t-submit-counteroffer' | translate}}
        </button>
    </div>
</ng-template>


<ng-template #contentWorkflowStep role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-success">
        <h5 class="modal-title">
            {{
            workflowMode === 'accept-and-step'
            ? ('t-proposals.t-workflow-accept-title' | translate)
            : ('t-proposals.t-workflow-step-title' | translate)
            }}
        </h5>
        <button type="button" id="proposal-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-4">
        <form [formGroup]="workflowStepForm">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label">{{ 't-proposals.t-workflow-next-step' | translate }}</label>
                    <ng-select [clearable]="false" [searchable]="false" formControlName="status" appendTo="body">
                        <ng-option [value]="'Reserved'">
                            {{ 't-proposals.t-status-reserved' | translate }}
                        </ng-option>
                        <ng-option [value]="'Sale Agreement'">{{ (isRentProposal(proposal) ?
                            't-proposals.t-status-lease-agreement' : 't-proposals.t-status-cpcv') | translate
                            }}</ng-option>
                    </ng-select>
                </div>
                <div class="col-12">
                    <label class="form-label">
                        {{
                        workflowMode === 'accept-and-step'
                        ? ('t-proposals.t-workflow-observations-accept' | translate)
                        : ('t-proposals.t-observations' | translate)
                        }}
                    </label>
                    <textarea class="form-control" formControlName="obs" rows="3"
                        [placeholder]="'t-proposals.t-observations' | translate"></textarea>
                </div>
                <div class="col-12">
                    <div class="form-check">
                        <input class="form-check-input" id="requestDocumentProposalView" type="checkbox"
                            formControlName="requestDocument" (change)="onWorkflowDocumentToggle()">
                        <label class="form-check-label" for="requestDocumentProposalView">
                            {{ 't-proposals.t-workflow-request-document' | translate }}
                        </label>
                    </div>
                </div>
                <div class="col-12" *ngIf="workflowStepForm.get('requestDocument')?.value">
                    <div class="form-check">
                        <input class="form-check-input" id="useDeadlineProposalView" type="checkbox"
                            formControlName="useDeadline">
                        <label class="form-check-label" for="useDeadlineProposalView">
                            {{ 't-proposals.t-workflow-use-deadline' | translate }}
                        </label>
                    </div>
                </div>
                <div class="col-md-6"
                    *ngIf="workflowStepForm.get('requestDocument')?.value && workflowStepForm.get('useDeadline')?.value">
                    <label class="form-label">{{ 't-proposals.t-workflow-deadline' | translate }}</label>
                    <input class="form-control flatpickr-input" type="text" mwlFlatpickr [enableTime]="true"
                        [convertModelValue]="true" [dateFormat]="'Y-m-d H:i'" formControlName="documentDeadline"
                        [placeholder]="'t-general.t-select' | translate" />
                </div>
                <div class="col-12">
                    <label class="form-label mb-0">{{ 't-proposals.t-file-input' | translate }}</label>
                    <input class="form-control mt-2" type="file" accept=".jpeg,.jpg,.png,.pdf,.doc,.docx" multiple (change)="onFileChangeWorkflow($event)">
                    <div class="d-flex align-items-center border border-dashed p-2 rounded mt-2"
                        *ngFor="let file of workflowStepForm.get('files')?.value; let i = index">
                        <div class="flex-grow-1">
                            <h6 class="mb-1">{{ file.name }}</h6>
                            <small class="text-muted">{{ formatSizeUnits(file.size) }}</small>
                        </div>
                        <a href="javascript:void(0);" class="text-muted" (click)="deleteWorkflowFile(i)">
                            <i class="ri-delete-bin-line"></i>
                        </a>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
            (click)="modal.close('')">{{ 't-proposals.t-cancel' | translate }}</button>
        <button type="button" class="btn btn-success w-xs" (click)="submitWorkflowStep()">
            {{ 't-save' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #contentUploadWorkflowDocument role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <h5 class="modal-title">{{ 't-proposals.t-upload-document' | translate }}</h5>
        <button type="button" id="proposal-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-4">
        <form [formGroup]="uploadWorkflowDocumentForm">
            <div class="row g-3">
                <div class="col-12">
                    <label class="form-label">{{ 't-proposals.t-file-input' | translate }}</label>
                    <input class="form-control" type="file" accept=".jpeg,.jpg,.png,.pdf,.doc,.docx" multiple (change)="onFileChangeUploadWorkflow($event)">
                    <div class="d-flex align-items-center border border-dashed p-2 rounded mt-2"
                        *ngFor="let file of uploadWorkflowDocumentForm.get('files')?.value; let i = index">
                        <div class="flex-grow-1">
                            <h6 class="mb-1">{{ file.name }}</h6>
                            <small class="text-muted">{{ formatSizeUnits(file.size) }}</small>
                        </div>
                        <a href="javascript:void(0);" class="text-muted" (click)="deleteUploadWorkflowFile(i)">
                            <i class="ri-delete-bin-line"></i>
                        </a>
                    </div>
                </div>
                <div class="col-12">
                    <label class="form-label">{{ 't-proposals.t-observations' | translate }}</label>
                    <textarea class="form-control" formControlName="obs" rows="3"
                        [placeholder]="'t-proposals.t-observations' | translate"></textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
            (click)="modal.close('')">{{ 't-proposals.t-cancel' | translate }}</button>
        <button type="button" class="btn btn-primary w-xs" (click)="submitUploadWorkflowDocument()">
            {{ 't-send' | translate }}
        </button>
    </div>
</ng-template>

<!-- Modal Sale -->
<ng-template #contentCheck role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <div class="d-flex align-items-center gap-2">
            <h5 class="modal-title" id="inviteMembersModalLabel">
                {{ (isRentProposal(proposal) ? 't-proposals.t-create-rent' : 't-proposals.t-create-sale') | translate }}
            </h5>
            <div *ngIf="proposal?.property?.saleInProgress"
                class="align-items-center badge badge-soft-warning d-flex fs-12 warning-badge">
                <i class="ri-error-warning-line text-warning me-1"></i>
                <span>{{ 't-new-sales.t-sale-details-warning' | translate }}</span>
            </div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <app-sale-form [formGroup]="propertyDetailsForm" [isRentMode]="!!proposal?.property?.isRent"
            [property]="proposal?.property" [paymentsConditions]="paymentsConditions ?? []"
            [pathProfileImage]="pathProfileImage" [openNewAgent]="openNewAgent" [selected]="selected"
            [agentsExceptListing]="agentsExceptListing" [agentsExceptSelling]="agentsExceptSelling"
            [showAgentSections]="true" [disableBySaleInProgress]="false" [allowSharedSellerHide]="true"
            [getAgentsFn]="getAgents.bind(this)" [getStoreByIdFn]="getStoreById.bind(this)"
            [getSuffixFn]="getSuffix.bind(this)" (addAgent)="addAgent($event)" [proposal]="proposal?.proposal"
            (removeAgent)="removeAgent($event.type, $event.id)" (changeAgent)="onChangeAgent($event.id, $event.type)"
            (addPaymentCondition)="addPaymentCondition()" (removePaymentCondition)="removePaymentCondition($event)"
            (paymentChange)="onPaymentChange($event)" (proposalChecked)="onProposalChecked($event)"
            [isProposalCheck]="true" [lockDealSelection]="!!linkedDealId" (paymentDropped)="drop($event)">
        </app-sale-form>
    </div>
</ng-template>

